// @ts-check
import { Box } from '.';

import React from 'react';

/**
 * @param {{
 * children: React.ReactNode;
 * direction?: import('@react-pdf/types').Style["flexDirection"];
 * wrap?: true | import('@react-pdf/types').Style["flexWrap"];
 * style?: import('@react-pdf/types').Style | (import('@react-pdf/types').Style | undefined)[];
 * debug?: boolean;
 * [x: string]: any;
 * }} props
 */
export default function Flex({
  children,
  direction = 'row',
  wrap,
  style,
  ...rest
}) {
  return (
    <Box
      style={[
        {
          display: 'flex',
          flexDirection: direction,
          flexWrap: wrap === true ? 'wrap' : wrap,
        },
        ...(Array.isArray(style) ? style : [style]),
      ]}
      {...rest}
    >
      {children}
    </Box>
  );
}
